import { constants } from '@config';
import AbstractElement from './abstractElement';

export default class Span extends AbstractElement {
  constructor (parameters) {
    super();

    this.textContent = '';

    // attributes
    this.cls = null;
    this.fill = null;
    this.highlight = null;
    this.font_family = null;
    this.font_size = null;

    this.text_decoration = null;
    this.font_weight = null;
    this.font_style = null;
    this.x = null;
    this.link = null;

    this.orderedWidth = 0;
    this.orderedFontSize = 0;
    this.orderedFill = null;
    this.orderedStart = null;
    this.orderedFontFamily = null;
    this.orderedFontWeight = null;
    this.orderedCustomFontId = null;

    this.bulletWidth = 0;
    this.bulletFontSize = 0;
    this.bulletFill = null;
    this.bulletFontFamily = null;
    this.bulletCustomFontId = null;
    this.bulletHighlight = null;
    this.bulletFontStyle = null;

    this.custom_font_id = null;
    this.font_stretch = null;
    this.data_paragraph_style = null;
    this.custom_placeholder = null;
    this.data_defined_placeholder = null;
    this.data_meta = null;

    this.letter_spacing = null;
    this.baseline_shift = null;

    this.setValues(parameters);
  }

  setDOM (dom) {
    if (!dom) return null;

    this.dom = dom;

    const isBlank = $(dom).parent().is('.blank');
    const a = dom.querySelector('a');
    const link = a && a.getAttribute('xlink:href');
    let fontSize = dom.getAttribute('font-size');
    fontSize = fontSize ? parseFloat(dom.getAttribute('font-size')) : null;

    const blankClassName = getClassName();

    const attrs = {
      cls: isBlank ? blankClassName : dom.getAttribute('class'),

      fill: dom.getAttribute('fill'),
      highlight: dom.getAttribute('highlight'),
      font_family: dom.getAttribute('font-family'),
      custom_font_id: dom.getAttribute('custom-font-id'),
      font_stretch: dom.getAttribute('font-stretch'),
      data_paragraph_style: Number(dom.getAttribute('data-paragraph-style')) || null,
      custom_placeholder: dom.getAttribute('custom-placeholder'),
      data_defined_placeholder: dom.getAttribute('data-defined-placeholder'),
      data_meta: dom.getAttribute('data-meta'),
      font_size: fontSize,
      text_decoration: dom.getAttribute('text-decoration'),
      font_weight: dom.getAttribute('font-weight'),
      font_style: dom.getAttribute('font-style'),
      baseline_shift: dom.getAttribute('baseline-shift'),
      orderedWidth: Number(dom.getAttribute('data-ordered-width')) || 0,
      orderedFontSize: Number(dom.getAttribute('font-size')) || 0,
      orderedFill: dom.getAttribute('fill') || null,
      bulletWidth: Number(dom.getAttribute('data-bullet-width')) || null,
      bulletFontSize: Number(dom.getAttribute('font-size')) || 0,
      bulletFill: dom.getAttribute('fill') || null,
      link,
      x: dom.getAttribute('x')
    };

    this.setValues($.extend(attrs, {
      textContent: dom.textContent
    }));

    return this;

    function getClassName () {
      let className = null;

      ['bullets', 'ordered'].forEach(validClassName => {
        if (dom.classList.contains(validClassName)) className = validClassName;
      });

      return className;
    }
  }

  hasSubelements () {
    return $(this.dom).has('tspan').length > 0;
  }

  isBullet () {
    return this.cls && this.cls.indexOf('bullets') > -1;
  }

  isOrdered () {
    return this.cls && this.cls.indexOf('ordered') > -1;
  }

  isOrderedBlank () {
    return this.cls && this.cls.indexOf('ordered') > -1 && this.cls.indexOf('blank') > -1;
  }

  getOrderDetails () {
    let details = { order: -1, mark: '.' };
    const content = this.textContent;

    if (this.isOrdered()) {
      details = { order: content.slice(0, content[content.length - 1]), mark: content[content.length - 1] };
    }

    return details;
  }

  getBulletDetails () {
    if (!this.isBullet()) return { customBulletSymbol: null };
    if (/\s/.test(this.textContent)) return { customBulletSymbol: null };

    const isDefaultSymbol = constants.text.bulletPoints.defaultSymbols.includes(this.textContent);

    return isDefaultSymbol ? { customBulletSymbol: null } : { customBulletSymbol: this.textContent };
  }

  setDefaultBullet (text) {
    this.cls = 'bullets';
    this.textContent = text || '•'; // U+25CF
    this.text_decoration = 'none'; // not working
    this.letter_spacing = 0;
    return this;
  }

  setDefaultIndent () {
    this.cls = 'bullets blank';
    this.textContent = '&nbsp;';
    this.text_decoration = 'none'; // not working
    this.letter_spacing = 0;
    return this;
  }

  setListItem (text) {
    this.cls = 'ordered';
    this.textContent = text;
    this.text_decoration = 'none';
    this.letter_spacing = 0;
    return this;
  }

  setListIndent () {
    this.cls = 'ordered blank';
    this.textContent = '&nbsp;';
    this.text_decoration = 'none';
    this.letter_spacing = 0;
    return this;
  }

  setSimpleText (text) {
    this.textContent = text;
    return this;
  }

  render (canvas) {
    const that = this;

    this.dom = canvas.addSvgElementFromJson({
      element: 'tspan',
      curStyles: false,
      attr: {}
    });

    that.resetFontDecoration();

    that.cls && this.dom.setAttribute('class', that.cls);

    that.fill && that.dom.setAttribute('fill', that.fill);
    that.highlight && that.dom.setAttribute('highlight', that.highlight);
    that.font_family && that.dom.setAttribute('font-family', that.font_family);
    that.font_size && that.dom.setAttribute('font-size', that.font_size);

    that.text_decoration && that.dom.setAttribute('text-decoration', that.text_decoration);
    that.font_weight && that.dom.setAttribute('font-weight', that.font_weight);
    that.font_style && that.dom.setAttribute('font-style', that.font_style);
    that.baseline_shift && that.dom.setAttribute('baseline-shift', that.baseline_shift);
    that.custom_placeholder && that.dom.setAttribute('custom-placeholder', that.custom_placeholder);
    that.data_defined_placeholder && that.dom.setAttribute('data-defined-placeholder', that.data_defined_placeholder);
    that.x && that.dom.setAttribute('x', that.x);

    // 0 val available:
    that.letter_spacing !== null && that.dom.setAttribute('letter-spacing', that.letter_spacing);
    that.dom.innerHTML = that.textContent.includes('<tspan')
      ? that.textContent
      : that.textContent.replace(/</g, '&lt;').replace(/>/g, '&gt;');

    return that.dom;
  }
}
